module.exports = __webpack_public_path__ + "img/seo-and-web.e29e5f43.svg";